import { render, staticRenderFns } from "./PointFilterDefaultLayout.vue?vue&type=template&id=65205ab4&scoped=true&"
import script from "./PointFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PointFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65205ab4",
  null
  
)

export default component.exports